const features = [
  {
    icon: 'ri-search-eye-line',
    title: 'Find Products Faster',
    description: 'Discover organized collections without endless searching. Browse curated categories and locate exactly what you need in seconds.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Compare Better',
    description: 'Review product information side by side before making decisions. Make informed choices with structured comparison tools.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Shop Smarter',
    description: 'Use guides and expert recommendations to improve your shopping experience. Learn proven strategies from experienced buyers.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Reduce Mistakes',
    description: 'Learn safety practices before purchasing. Avoid common pitfalls with QC tips and verified seller recommendations.',
  },
];

export default function Features() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-700 bg-primary-100/70 rounded-full mb-4 tracking-wide">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Why Use Superbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            The ultimate resource system that transforms how international shoppers discover and compare products
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-100/70 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 hover:bg-background-50"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}